'use client'

import './header-mobile.css'

import { Menu } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import { useRef, useState } from 'react'
import CSSTransition from 'react-transition-group/CSSTransition'

import HeaderMobileMenu from './header-mobile-menu'

export const HeaderMobile = () => {
  const [menuIsOpen, setMenuIsOpen] = useState(false)
  const menuRef = useRef(null)

  const handleOpenMenuClick = () => {
    setMenuIsOpen(true)
  }

  const handleCloseMenuClick = () => {
    setMenuIsOpen(false)
  }

  return (
    <header className="sticky top-0 z-50 flex items-center justify-between bg-white px-5 py-10 shadow lg:hidden">
      <Link href="/#home">
        <Image
          src="/icons/logo-text.svg"
          alt="Doutor Sim"
          width={124}
          height={28}
        />
      </Link>
      <Menu
        className="h-9 w-9 text-brand-green-primary-5"
        onClick={handleOpenMenuClick}
      />

      <CSSTransition
        nodeRef={menuRef}
        in={menuIsOpen}
        timeout={200}
        classNames="menu-node"
        unmountOnExit
      >
        <HeaderMobileMenu
          ref={menuRef}
          handleCloseClick={handleCloseMenuClick}
        />
      </CSSTransition>
    </header>
  )
}
